export const formatDateObjectToISODate = (date: Date): string => {
  const year = date.getUTCFullYear(); // Use getUTCFullYear() to avoid timezone issues
  const month = date.getUTCMonth() + 1; // Use getUTCMonth() to get the month in UTC
  const day = date.getUTCDate(); // Use getUTCDate() to get the day in UTC

  const monthStr = month < 10 ? '0' + month.toString() : month.toString();
  const dayStr = day < 10 ? '0' + day.toString() : day.toString();

  return `${year}-${monthStr}-${dayStr}`;
};

export const minDateCheck = () => {
  return new Date(new Date().getFullYear() - 100, new Date().getMonth(), new Date().getDate());
};

export const maxDateCheck = () => {
  return new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate());
};
